import React, {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import cookies from 'src/libs/cookies';
import { roleSet } from '../../constants/role';
import { AuthCookie, UserCookie } from './types';
import * as signalR from '@microsoft/signalr';
import { copyObject } from 'src/components/_shared/utils';
import { useLocation, useNavigate } from 'react-router';
import { useNewId } from 'src/hooks/isNewId';
import { API_HOSTNAME } from 'src/libs/axios';
import { alertError } from 'src/libs/toastify';

function removeDuplicates<T>(arr: T[]): T[] {
  return arr.filter((item: T, index: number) => arr.indexOf(item) === index);
}

export type BlockedOrder = {
  isBlocked: boolean;
  orderId: number;
  userId: number;
};

const BLOCKED_ORDERS_RECONCILIATION_INTERVAL_MS = 30_000;

function getOrderLockOwnerToken(orderId: number): string {
  const storageKey = `order-lock-owner:${orderId}`;
  let ownerToken = sessionStorage.getItem(storageKey);

  if (!ownerToken) {
    ownerToken = crypto.randomUUID();
    sessionStorage.setItem(storageKey, ownerToken);
  }

  return ownerToken;
}

interface employeeStatusI {
  online: string[];
  inactive: string[];
}

type StatusContextValue = {
  employeeStatus: employeeStatusI;
  blockedOrders: BlockedOrder[];
  isConnected: boolean;
  handlers: {
    openOrder(id: number): Promise<{ canOpen: boolean; userId: number }>;
    closeOrder(id: number): Promise<boolean>;
    getBlockedOrders(): Promise<BlockedOrder[]>;
  };
};

const missingStatusProvider = () =>
  Promise.reject(new Error('StatusProvider is not mounted'));

export const StatusContext = createContext<StatusContextValue>({
  employeeStatus: { online: [], inactive: [] },
  blockedOrders: [],
  isConnected: false,
  handlers: {
    openOrder: missingStatusProvider,
    closeOrder: missingStatusProvider,
    getBlockedOrders: missingStatusProvider,
  },
});
export const useStatusContext = () => useContext(StatusContext);

interface StatusProviderProps {
  children: ReactNode;
}

export const StatusProvider: FC<StatusProviderProps> = ({ children }) => {
  const auth: AuthCookie | undefined = cookies.get('auth');
  const user: UserCookie | undefined = cookies.get('user');
  const token = auth?.accessToken || '';

  const { id, isNew } = useNewId();
  const location = useLocation();
  const navigate = useNavigate();
  const orderId =
    location.pathname.includes('dispatcher/order-form') && !isNew
      ? id
      : undefined;
  const currentOrderId = orderId ? Number(orderId) : undefined;
  const openOrderIdRef = useRef(currentOrderId);
  openOrderIdRef.current = currentOrderId;

  // const [employeeStatus, setEmployeesStatus] = useState<employeeStatusI>({
  //   online: [],
  //   inactive: [],
  // });

  // const sendOnlineStatus = () => {
  //   if (user?.role && roleSet.operatorToSuperAdmin.includes(user.role)) {
  //     // API.post(`/signalRSend`, {
  //     //   userId: user?.id,
  //     //   userName: user?.firstName,
  //     //   status: 0,
  //     // });
  //   }
  // };

  // const [isNeedToSend, setIsNeedToSend] = useState(false);

  // useEffect(() => {
  //   if (isNeedToSend) {
  //     sendOnlineStatus();
  //     const id = setTimeout(() => {
  //       clearTimeout(id);
  //       setIsNeedToSend(false);
  //     }, 1000);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isNeedToSend, user]);

  // useEffect(() => {
  // if (user?.role && roleSet.operatorToSuperAdmin.includes(user.role)) {
  // const id = setInterval(() => {
  //   const myListener = function () {
  //     setIsNeedToSend(true);
  //     document.removeEventListener('mousemove', myListener, false);
  //   };
  //   document.addEventListener('mousemove', myListener, false);
  // }, 30000);
  // if (!isConnectedOrdersSignalR) {
  // const connection = new signalR.HubConnectionBuilder()
  //   .withUrl(`/statusHub`, {
  //     accessTokenFactory: () => token,
  //   })
  //   .configureLogging(signalR.LogLevel.Debug)
  //   .build();

  // connection
  //   .start()
  //   .then(() => console.log('SignalR connected'))
  //   .catch((error) => console.error('SignalR error', error.toString()));

  // connection.on('Receive', (response) => {
  //   if (response.status === 0) {
  //     setEmployeesStatus((employeeStatus) => {
  //       if (employeeStatus) {
  //         const newEmployeesStatus = copyObject(employeeStatus);
  //         newEmployeesStatus.online = removeDuplicates([
  //           ...newEmployeesStatus.online,
  //           response.userId,
  //         ]);
  //         newEmployeesStatus.inactive =
  //           newEmployeesStatus.inactive.filter(
  //             (el: string) => el !== response.userId
  //           );
  //         return newEmployeesStatus;
  //       } else {
  //         return employeeStatus;
  //       }
  //     });
  //   } else if (response.status === 2) {
  //     setEmployeesStatus((employeeStatus) => {
  //       if (employeeStatus) {
  //         const newEmployeesStatus = copyObject(employeeStatus);
  //         newEmployeesStatus.inactive = removeDuplicates([
  //           ...newEmployeesStatus.inactive,
  //           response.userId,
  //         ]);
  //         newEmployeesStatus.online = newEmployeesStatus.online.filter(
  //           (el: string) => el !== response.userId
  //         );
  //         return newEmployeesStatus;
  //       } else {
  //         return employeeStatus;
  //       }
  //     });
  //   } else {
  //     setEmployeesStatus((employeeStatus) => {
  //       if (employeeStatus) {
  //         const newEmployeesStatus = copyObject(employeeStatus);
  //         newEmployeesStatus.online = newEmployeesStatus.online.filter(
  //           (el: string) => el !== response.userId
  //         );
  //         newEmployeesStatus.inactive =
  //           newEmployeesStatus.inactive.filter(
  //             (el: string) => el !== response.userId
  //           );
  //         return newEmployeesStatus;
  //       } else {
  //         return employeeStatus;
  //       }
  //     });
  //   }
  // });
  // connection.on('IncomingCall', (response) => {
  //   console.log(response);
  // });

  // }
  // return () => clearInterval(id);
  // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [token, isConnectedOrdersSignalR]);

  // Orders SignalR
  const connectionRef = useRef<signalR.HubConnection | null>(null);
  const orderLockTransitionRef = useRef<Promise<void>>(Promise.resolve());
  const lockedOrderIdRef = useRef<number>();
  const [isHubConnected, setIsHubConnected] = useState(false);
  const [lockedOrderId, setLockedOrderId] = useState<number>();
  const [blockedOrders, setBlockedOrders] = useState<BlockedOrder[]>([]);
  const [employeeStatus] = useState<employeeStatusI>({
    online: [],
    inactive: [],
  });
  const updateLockedOrderId = useCallback((id?: number) => {
    lockedOrderIdRef.current = id;
    setLockedOrderId(id);
  }, []);
  const isConnected =
    isHubConnected && (!currentOrderId || lockedOrderId === currentOrderId);

  useEffect(() => {
    let disposed = false;
    const baseUrl = API_HOSTNAME.endsWith('/')
      ? API_HOSTNAME
      : `${API_HOSTNAME}/`;
    const hubUrl = `${baseUrl}orderStatusHub`;
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, {
        accessTokenFactory: () => token,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Debug)
      .build();

    let isSynchronizingBlockedOrders = false;
    const synchronizeBlockedOrders = async () => {
      if (isSynchronizingBlockedOrders) return;

      isSynchronizingBlockedOrders = true;
      try {
        const orders = await connection.invoke<BlockedOrder[]>(
          'GetBlockedOrders'
        );
        if (!disposed) setBlockedOrders(orders ?? []);
      } finally {
        isSynchronizingBlockedOrders = false;
      }
    };

    const blockOrder = (order: BlockedOrder) => {
      setBlockedOrders((current) => [
        ...current.filter(({ orderId }) => orderId !== order.orderId),
        order,
      ]);
    };
    const unblockOrder = (order: BlockedOrder) => {
      setBlockedOrders((current) =>
        current.filter(({ orderId }) => orderId !== order.orderId)
      );
    };

    const ensureOpenOrderLock = async () => {
      const openOrderId = openOrderIdRef.current;
      if (!openOrderId) return true;

      const lockResult = await connection.invoke<BlockedOrder>(
        'TryBlockOrder',
        Number(openOrderId),
        getOrderLockOwnerToken(Number(openOrderId))
      );

      if (!lockResult.isBlocked) {
        if (!disposed) updateLockedOrderId(openOrderId);
        return true;
      }

      if (!disposed) {
        alertError(
          null,
          `Заказ №${openOrderId} находится в обработке другим сотрудником`
        );
        navigate('/main/dispatcher', { replace: true });
      }

      return false;
    };

    connectionRef.current = connection;
    setIsHubConnected(false);

    // Register handlers before start so no server event can be missed.
    connection.on('TryBlockOrder', blockOrder);
    connection.on('TryUnblockOrder', unblockOrder);
    connection.onreconnecting(() => {
      if (!disposed) setIsHubConnected(false);
    });
    connection.onreconnected(async () => {
      if (disposed) return;

      try {
        if (!(await ensureOpenOrderLock())) return;

        await synchronizeBlockedOrders();
        if (!disposed) setIsHubConnected(true);
      } catch (error) {
        console.error('Unable to synchronize blocked orders:', error);
      }
    });
    connection.onclose((error) => {
      if (disposed) return;

      setIsHubConnected(false);
      if (error) console.error('SignalR Orders connection closed:', error);
    });

    const connect = async () => {
      try {
        await connection.start();
        if (disposed) return;

        if (!(await ensureOpenOrderLock())) return;

        await synchronizeBlockedOrders();
        if (!disposed) setIsHubConnected(true);
      } catch (error) {
        if (!disposed) {
          setIsHubConnected(false);
          console.error('SignalR Orders connection failed:', error);
        }
      }
    };

    void connect();

    const reconciliationIntervalId = window.setInterval(() => {
      if (
        disposed ||
        connection.state !== signalR.HubConnectionState.Connected
      ) {
        return;
      }

      void synchronizeBlockedOrders().catch((error) => {
        console.error('Unable to synchronize blocked orders:', error);
      });
    }, BLOCKED_ORDERS_RECONCILIATION_INTERVAL_MS);

    return () => {
      disposed = true;
      window.clearInterval(reconciliationIntervalId);
      if (connectionRef.current === connection) connectionRef.current = null;
      connection.off('TryBlockOrder', blockOrder);
      connection.off('TryUnblockOrder', unblockOrder);
      void connection.stop();
    };
  }, [navigate, token, updateLockedOrderId]);

  useEffect(() => {
    if (!isHubConnected || lockedOrderIdRef.current === currentOrderId) {
      return;
    }

    let cancelled = false;
    const synchronizeOpenOrderLock = async () => {
      const connection = connectionRef.current;
      if (
        !connection ||
        connection.state !== signalR.HubConnectionState.Connected
      ) {
        return;
      }

      const previouslyLockedOrderId = lockedOrderIdRef.current;
      if (
        previouslyLockedOrderId &&
        previouslyLockedOrderId !== currentOrderId
      ) {
        await connection.invoke<boolean>(
          'TryUnblockOrder',
          previouslyLockedOrderId
        );

        if (lockedOrderIdRef.current === previouslyLockedOrderId) {
          updateLockedOrderId();
        }
      }

      if (
        !currentOrderId ||
        cancelled ||
        openOrderIdRef.current !== currentOrderId
      ) {
        return;
      }

      const lockResult = await connection.invoke<BlockedOrder>(
        'TryBlockOrder',
        currentOrderId,
        getOrderLockOwnerToken(currentOrderId)
      );

      if (cancelled || openOrderIdRef.current !== currentOrderId) {
        if (!lockResult.isBlocked) {
          await connection.invoke<boolean>('TryUnblockOrder', currentOrderId);
        }
        return;
      }

      if (lockResult.isBlocked) {
        alertError(
          null,
          `Заказ №${currentOrderId} находится в обработке другим сотрудником`
        );
        navigate('/main/dispatcher', { replace: true });
        return;
      }

      updateLockedOrderId(currentOrderId);
    };

    const transition = orderLockTransitionRef.current.then(
      synchronizeOpenOrderLock,
      synchronizeOpenOrderLock
    );
    orderLockTransitionRef.current = transition.catch((error) => {
      console.error('Unable to synchronize the open order lock:', error);
    });

    return () => {
      cancelled = true;
    };
  }, [currentOrderId, isHubConnected, navigate, updateLockedOrderId]);

  const getConnectedHub = useCallback(() => {
    const connection = connectionRef.current;
    if (
      !connection ||
      connection.state !== signalR.HubConnectionState.Connected
    ) {
      throw new Error('The order status connection is not connected');
    }

    return connection;
  }, []);

  const openOrder = useCallback(
    async (id: number) => {
      const result = await getConnectedHub().invoke<BlockedOrder>(
        'TryBlockOrder',
        id,
        getOrderLockOwnerToken(id)
      );

      if (!result.isBlocked) updateLockedOrderId(id);

      return {
        canOpen: !result.isBlocked,
        userId: result.userId,
      };
    },
    [getConnectedHub, updateLockedOrderId]
  );

  const closeOrder = useCallback(
    async (id: number) => {
      const released = await getConnectedHub().invoke<boolean>(
        'TryUnblockOrder',
        id
      );

      if (released && lockedOrderIdRef.current === id) {
        updateLockedOrderId();
      }

      return released;
    },
    [getConnectedHub, updateLockedOrderId]
  );

  const getBlockedOrders = useCallback(async () => {
    const orders = await getConnectedHub().invoke<BlockedOrder[]>(
      'GetBlockedOrders'
    );
    setBlockedOrders(orders ?? []);
    return orders ?? [];
  }, [getConnectedHub]);

  return (
    <StatusContext.Provider
      value={{
        employeeStatus,
        blockedOrders,
        isConnected,
        handlers: { openOrder, closeOrder, getBlockedOrders },
      }}
    >
      {children}
    </StatusContext.Provider>
  );
};
